import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import Form from '@components/library/form/Form';
import InputContainer from '@components/library/input_container/InputContainer';
import renderModal from '@components/show_page/modals/renderModal';
import { create as submitApproval } from '@api/v4/resources/share_manifests';
import { pluralizeObject } from '@helpers/show_page_helpers';

const DownloadAccessResponse = ({
  closeModal,
  requestDownloadName,
  requestDownloadRequestee,
  selectedAssetKeys,
}) => {
  const [formDisabled, setFormDisabled] = useState(false);

  useEffect(() => (() => closeModal()), []);

  const assetQtyObject = pluralizeObject(selectedAssetKeys);
  const successOptions = {
    type: 'success',
    title: bfTranslate('Success!'),
    text: bfTranslate(`You have approved ${assetQtyObject.qty} asset${assetQtyObject.plural} for download from the ${requestDownloadName} Share Link`),
    showCancelButton: true,
    showConfirmButton: false,
    cancelButtonText: bfTranslate('Close'),
    allowOutsideClick: true,
    customClass: 'swal-request-download-confirmation',
  };

  const handleSubmit = (inputs) => {
    setFormDisabled(true);
    const { key, type } = BFG.resource;

    submitApproval({
      key,
      type,
      assetKeys: [...selectedAssetKeys],
      downloadRequestKey: BFG.downloadRequestKey,
      message: inputs.message.value,
      name: requestDownloadName,
      requestApproval: true
    })
      .then(() => {
        window.swal(successOptions);
      })
      .catch((err) => {
        setFormDisabled(false);
        console.log(err);
      });
  };

  return (
    <div className="modal-content-wrapper request-download-modal">
      <div className="modal-content-wrapper__header">
        <span aria-hidden="true" className="bff-request-download icon" />
        <h3 className="modal-title">{bfTranslate('Download Access Approval')}</h3>
        <button
          className="close-button"
          onClick={closeModal}
          type="button"
        >
          <span className="bff-close" />
        </button>
      </div>
      <div className="modal-content-wrapper__body">
        <div>
          <h3 className="body-title">
            {bfTranslate(`Send ${requestDownloadRequestee} a message to accompany your approval.`)}
          </h3>
          <Form
            disabledByParent={formDisabled}
            onSubmit={handleSubmit}
            submitButtonText={bfTranslate('Approve')}
          >
            <InputContainer
              attributes={{ type: 'textarea', name: 'message' }}
              validationRules={{ isRequired: false }}
            />
          </Form>
        </div>
      </div>
    </div>
  );
};

DownloadAccessResponse.propTypes = {
  closeModal: PropTypes.func.isRequired,
  requestDownloadName: PropTypes.string.isRequired,
  requestDownloadRequestee: PropTypes.string.isRequired,
  selectedAssetKeys: PropTypes.instanceOf(Set).isRequired,
};

const ModalComponent = renderModal(DownloadAccessResponse, 'request-download-access-modal');
export default ModalComponent;
